import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Message } from '../shared/message.model';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'app/shared/global.service';
import { Setting } from 'app/settings/shared/setting.model';
import { SettingFactory } from 'app/settings/shared/setting.factory';
import { MessageFactory } from '../shared/message.factory';
import { AngularFireStorage } from 'angularfire2/storage';

@Component({
    selector: 'app-message-detail',
    templateUrl: './message-detail.component.html'
})

export class MessageDetailComponent implements OnInit {

    public message: Message = MessageFactory.empty();
    public reply: any;
    public settings: Setting = SettingFactory.empty()
    public downloadURL: any;

    constructor(private globalService: GlobalService, 
        private activatedRoute: ActivatedRoute,
        private storage: AngularFireStorage) {
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.globalService.getMessage(params['uid'], params['mid']).subscribe(data => {
                this.message = data.message;
                this.settings = data.settings;
                if (data.settings && data.settings.banner) {
                    const pathReference = this.storage.ref(data.settings.banner);
                    this.downloadURL = pathReference.getDownloadURL();
                }

                this.globalService.readMessage(params['uid'], data.message.user.id, params['mid']).subscribe(data => {
                });

                if (params['rid']) {
                    this.globalService.getMessageReply(params['uid'], params['mid'], params['rid']).subscribe(data => {
                        this.reply = data;
                    })
                }
            })
        })
    }
}




// WEBPACK FOOTER //
// ./src/app/messages/message-detail/message-detail.component.ts